import React, { useEffect, useState } from "react"
import { Link, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import DeleteModal from 'pages/parts/DeleteModal'

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { formatMoney, formatDate } from 'helpers/helpers'


function Index() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [data, setData] = useState([])
	const [accounts, setAccounts] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ 'id': 0, 'index': 0 })

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/cashbox', selectedItem, { loader: true })
		} else {
			response = await POST('/cashbox', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			getData()
			toggleModal()
		}
	}

	async function deleteItem() {
		const response = await DELETE(`/cashbox/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			getData()
			setModalDelete(false)
		}
	}

	function toggleModal(bool = false, item = {}) {
		setShowModal(bool)
		setSelectedItem(item)
	}

	function goTo(url) {
		navigate(url)
	}

	function returnClassStatus(item) {
		if ((item.shift && !item?.shift?.closed_at)) {
			return "bg-success text-white"
		}
		if (item?.shift?.closed_at) {
			return "bg-danger text-white"
		}

	}

	async function getData() {
		const response = await GET('/cashbox', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	useEffect(() => {
		getData()
		getAccounts()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('cashboxes')}
				</h4>
				<div className="d-flex d-none">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }} className="td-ellipsis">{t('pos')}</th>
									<th style={{ 'width': '20%' }} className="td-ellipsis">{t('cashbox')}</th>
									<th style={{ 'width': '20%' }} className="td-ellipsis">{t('employee')}</th>
									<th style={{ 'width': '20%' }}></th>
									<th style={{ 'minWidth': '125px' }} className="text-nowrap text-center">{t('open')}</th>
									<th style={{ 'minWidth': '125px' }} className="text-nowrap text-center">{t('closed')}</th>
									<th style={{ 'width': '10%' }}>{t('status')}</th>
									<th style={{ 'width': '10%' }} className="text-nowrap text-end">{t('cashbox_balance')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index} className="cursor" onClick={() => goTo(`/cashbox/shift/${item.id}`)}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">{item.pos_name}</td>
										<td className="td-ellipsis">
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td className="td-ellipsis">{item?.shift?.cashier_name}</td>
										<td></td>
										<td className="text-center">
											{item?.shift?.opened_at && <span>{formatDate(item?.shift?.opened_at, 'dd.MM.yy HH:mm')}</span>}
										</td>
										<td className="text-center">
											<span>{formatDate(item?.shift?.closed_at, 'dd.MM.yy HH:mm')}</span>
										</td>
										<td className={`text-center ${returnClassStatus(item)}`}>
											{(item.shift && !item?.shift?.closed_at) && <span>{t('open')}</span>}
											{item?.shift?.closed_at && <span>{t('closed')}</span>}
										</td>
										<td className="text-end text-nowrap">{formatMoney(item?.shift?.balance)}</td>
										<td onClick={(e) => e.stopPropagation()}>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Link to={`/cashbox/shift/${item.id}`} className="table-dropdown-item">
															<i className="uil-eye"></i>
															{t('shifts')}
														</Link>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil uil-edit"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item text-danger d-none"
															onClick={() => {
																setDeleteModalParams({ id: item.id, index: index });
																setModalDelete(true)
															}}>
															<i className="uil uil-times"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false}
				centered dialogClassName="update-modal-width"
 onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('cashbox_name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>	

						<div className="form-group">
							<label>{t('account_cash')}<span className="required-mark">*</span></label>
							<Select
								isDisabled
								options={accounts}
								value={accounts.find(option => option.id === selectedItem.account_cash_id)}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('account_terminal')}<span className="required-mark">*</span></label>
							<Select
								isDisabled
								options={accounts}
								value={accounts.find(option => option.id === selectedItem.account_terminal_id)}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t('automatic accrual')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'is_auto': true })}
											style={{ 'backgroundColor': selectedItem.is_auto ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'is_auto': true })}>
											{t('yes')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'is_auto': false })}
											style={{ 'backgroundColor': !selectedItem.is_auto ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'is_auto': false })}>
											{t('no')}
										</span>
									</div>
								</div>
							</div>
						</div>

						<div className="form-group">
							<label>{t('default')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'is_default': true })}
											style={{ 'backgroundColor': selectedItem.is_default ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'is_default': true })}>
											{t('yes')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'is_default': false })}
											style={{ 'backgroundColor': !selectedItem.is_default ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'is_default': false })}>
											{t('no')}
										</span>
									</div>
								</div>
							</div>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index
